<template>
  <div class="feature-block">
    <div class="feature-block__header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <CIcon
            name="cipInfo"
            size="sm"
            class="mr-2 feature-block__help"
            v-c-tooltip="{
              content: $pgettext('features.photo_editor', 'Allow users to edit photos directly from the photo browser. Opens an external editor with the HD version of the photo.'),
              placement: 'top',
              appendToBody: true
            }"
          />
          <span class="feature-block__title" v-translate translate-context="features.photo_editor">
            Photo Editor
          </span>
        </div>
        <CSwitch
          color="primary"
          variant="3d"
          size="sm"
          :checked="localEnabled"
          @update:checked="localEnabled = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturePhotoEditor',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      localEnabled: false
    }
  },
  watch: {
    config: {
      handler() {
        this.reset()
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.localEnabled = this.config?.enabled === true
    },
    getConfig() {
      return {
        enabled: this.localEnabled
      }
    }
  }
}
</script>
